module.exports = __webpack_public_path__ + "fe03dfa5f96a083eede69343e32bff95.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/skaters-shack-empty.png
// module id = 329
// module chunks = 0